module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dash"
    }
  }, [_c('dash-header', {
    attrs: {
      "logoMini": _vm.app.logoMini,
      "header": _vm.app.header,
      "subHeader": _vm.app.subHeader,
      "version": _vm.app.version,
      "currentUser": _vm.app.currentUser,
      "nowLang": _vm.app.nowLang,
      "toggleControlsidebar": _vm.toggleControlsidebar,
      "controlsidebarDisp": _vm.controlsidebarDisp,
      "postLogout": _vm.app.postLogout,
      "headerNotiAnnounceTotal": _vm.headerNotiAnnounceTotal,
      "headerNotiAnnounceInfiniteLoading": _vm.headerNotiAnnounceInfiniteLoading,
      "headerNotiRequestTotal": _vm.headerNotiRequestTotal,
      "headerNotiRequestInfiniteLoading": _vm.headerNotiRequestInfiniteLoading,
      "headerNotiApprove": _vm.headerNotiApprove,
      "receivedHeaderNotiRequestInfiniteLoading": _vm.receivedHeaderNotiRequestInfiniteLoading,
      "receivedHeaderNotiAnnounceInfiniteLoading": _vm.receivedHeaderNotiAnnounceInfiniteLoading,
      "toggleSidebar": _vm.toggleSidebar,
      "pcDisp": _vm.app.pcDisp,
      "closeSidebarMobile": _vm.closeSidebarMobile,
      "profileimg": _vm.profileimg,
      "allLang": _vm.app.allLang,
      "focusLang": _vm.app.focusLang,
      "setLang": _vm.app.setLang
    }
  }), _vm._v(" "), _c('dash-sidebar', {
    attrs: {
      "fontIcon": _vm.app.fontIcon,
      "currModule": _vm.currModule,
      "currCodapp": _vm.currCodapp,
      "version": _vm.app.version,
      "currentUser": _vm.app.currentUser,
      "nowLang": _vm.app.nowLang,
      "modules": _vm.modules,
      "mainMenu": _vm.app.mainMenu,
      "menuRequest": _vm.app.menuRequest,
      "menuApprove": _vm.app.menuApprove,
      "menu": _vm.app.menu,
      "rescale": _vm.rescale,
      "closeControlsidebar": _vm.closeControlsidebar,
      "controlsidebarDisp": _vm.controlsidebarDisp,
      "pcDisp": _vm.app.pcDisp,
      "closeSidebarMobile": _vm.closeSidebarMobile,
      "profileimg": _vm.profileimg
    }
  }), _vm._v(" "), _c('dash-body', {
    attrs: {
      "fontIcon": _vm.app.fontIcon,
      "currModule": _vm.currModule,
      "currCodapp": _vm.currCodapp,
      "nameModule": _vm.nameModule,
      "descCodapp": _vm.descCodapp,
      "codapp": _vm.codapp,
      "descModule": _vm.descModule,
      "closeControlsidebar": _vm.closeControlsidebar,
      "controlsidebarDisp": _vm.controlsidebarDisp,
      "pcDisp": _vm.app.pcDisp,
      "closeSidebarMobile": _vm.closeSidebarMobile
    }
  }), _vm._v(" "), _c('dash-footer', {
    attrs: {
      "version": _vm.app.version
    }
  }), _vm._v(" "), _c('dash-controlsidebar', {
    attrs: {
      "nowLang": _vm.app.nowLang,
      "allLang": _vm.app.allLang,
      "focusLang": _vm.app.focusLang,
      "setLang": _vm.app.setLang,
      "postLogout": _vm.app.postLogout,
      "controlsidebarDisp": _vm.controlsidebarDisp,
      "toggleControlsidebar": _vm.toggleControlsidebar,
      "mailLang": _vm.mailLang,
      "postControlsidebarMailLang": _vm.postControlsidebarMailLang
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7569a892!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dash/component.vue
// module id = 3873
// module chunks = 1